"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButton = exports.IconButton = exports.DestructiveButton = exports.FlatButton = exports.SecondaryButton = exports.PrimaryButton = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importStar(require("react"));
var react_aria_components_1 = require("react-aria-components");
var Links_1 = require("../Links");
var Tooltip_1 = require("../Tooltip");
var styles_1 = require("./styles");
var useButtonState = function (props) {
    var isTooltipTrigger = (0, react_1.useContext)(Tooltip_1.TooltipTriggerContext).isTooltipTrigger;
    // Only actually disable the button if it's NOT a tooltip trigger
    var isDisabled = props.isDisabled && !isTooltipTrigger;
    // Set the button to pending if it's pending OR it's both disabled and a tooltip trigger
    // This will make the button look visually disabled, prevent onPress from firing, but still allow hover and focus to trigger the tooltip
    var isPending = props.isPending || (props.isDisabled && isTooltipTrigger)
        ? true
        : undefined;
    return {
        isDisabled: isDisabled,
        isPending: isPending,
    };
};
var StyledPrimaryButton = (0, styled_1.default)(react_aria_components_1.Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), styles_1.BaseButtonStyles, styles_1.PrimaryButtonStyles);
/**
 * The primary button variant, used for the main action in a form or dialog.
 * It has a solid background color and high contrast to draw attention.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Button.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-buttons--primary}
 *
 * @example
 * ```tsx
 * <PrimaryButton onPress={() => alert('Clicked')}>
 *   Submit
 * </PrimaryButton>
 * ```
 *
 * @param children - The content to display inside the button
 * @param isDisabled - Whether the button is disabled. Defaults to false
 * @param type - The behavior of the button when used in an HTML form. Defaults to 'button'
 * @param onPress - Handler that is called when the press is released over the target
 * @param onPressStart - Handler that is called when a press interaction starts
 * @param onPressEnd - Handler that is called when a press interaction ends
 * @param onPressChange - Handler that is called when the press state changes
 * @param onPressUp - Handler that is called when a press is released over the target
 * @param onKeyDown - Handler that is called when a key is pressed
 * @param onKeyUp - Handler that is called when a key is released
 * @param onKeyPress - Handler that is called when a key is pressed
 * @param onFocus - Handler that is called when the button receives focus
 * @param onBlur - Handler that is called when the button loses focus
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param autoFocus - Whether the button should receive focus on render. Defaults to false
 * @param onHoverStart - Handler that is called when a hover interaction starts
 * @param onHoverEnd - Handler that is called when a hover interaction ends
 * @param onHoverChange - Handler that is called when the hover state changes
 */
exports.PrimaryButton = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = useButtonState({
        isDisabled: props.isDisabled,
        isPending: props.isPending,
    }), isDisabled = _b.isDisabled, isPending = _b.isPending;
    return (react_1.default.createElement(StyledPrimaryButton, __assign({}, props, { ref: ref, isDisabled: isDisabled, isPending: isPending }), children));
});
var StyledSecondaryButton = (0, styled_1.default)(react_aria_components_1.Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), styles_1.BaseButtonStyles, styles_1.SecondaryButtonStyles);
/**
 * The secondary button variant, used for alternative or less important actions.
 * It has a grey background with a border to create visual hierarchy.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Button.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-buttons--secondary}
 *
 * @example
 * ```tsx
 * <SecondaryButton onPress={() => alert('Clicked')}>
 *   Cancel
 * </SecondaryButton>
 * ```
 *
 * @param children - The content to display inside the button
 * @param isDisabled - Whether the button is disabled. Defaults to false
 * @param type - The behavior of the button when used in an HTML form. Defaults to 'button'
 * @param onPress - Handler that is called when the press is released over the target
 * @param onPressStart - Handler that is called when a press interaction starts
 * @param onPressEnd - Handler that is called when a press interaction ends
 * @param onPressChange - Handler that is called when the press state changes
 * @param onPressUp - Handler that is called when a press is released over the target
 * @param onKeyDown - Handler that is called when a key is pressed
 * @param onKeyUp - Handler that is called when a key is released
 * @param onKeyPress - Handler that is called when a key is pressed
 * @param onFocus - Handler that is called when the button receives focus
 * @param onBlur - Handler that is called when the button loses focus
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param autoFocus - Whether the button should receive focus on render. Defaults to false
 * @param onHoverStart - Handler that is called when a hover interaction starts
 * @param onHoverEnd - Handler that is called when a hover interaction ends
 * @param onHoverChange - Handler that is called when the hover state changes
 */
exports.SecondaryButton = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = useButtonState({
        isDisabled: props.isDisabled,
        isPending: props.isPending,
    }), isDisabled = _b.isDisabled, isPending = _b.isPending;
    return (react_1.default.createElement(StyledSecondaryButton, __assign({}, props, { ref: ref, isDisabled: isDisabled, isPending: isPending }), children));
});
var StyledFlatButton = (0, styled_1.default)(react_aria_components_1.Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), styles_1.BaseButtonStyles, styles_1.FlatButtonStyles);
/**
 * The flat button variant, used for subtle actions that don't need to draw attention.
 * It has no background or border, making it less prominent than other button variants.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Button.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-buttons--flat}
 *
 * @example
 * ```tsx
 * <FlatButton onPress={() => alert('Clicked')}>
 *   Learn more
 * </FlatButton>
 * ```
 *
 * @param children - The content to display inside the button
 * @param onDarkBackground - Whether the button is being used on a dark background. Defaults to false
 * @param isDisabled - Whether the button is disabled. Defaults to false
 * @param type - The behavior of the button when used in an HTML form. Defaults to 'button'
 * @param onPress - Handler that is called when the press is released over the target
 * @param onPressStart - Handler that is called when a press interaction starts
 * @param onPressEnd - Handler that is called when a press interaction ends
 * @param onPressChange - Handler that is called when the press state changes
 * @param onPressUp - Handler that is called when a press is released over the target
 * @param onKeyDown - Handler that is called when a key is pressed
 * @param onKeyUp - Handler that is called when a key is released
 * @param onKeyPress - Handler that is called when a key is pressed
 * @param onFocus - Handler that is called when the button receives focus
 * @param onBlur - Handler that is called when the button loses focus
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param autoFocus - Whether the button should receive focus on render. Defaults to false
 * @param onHoverStart - Handler that is called when a hover interaction starts
 * @param onHoverEnd - Handler that is called when a hover interaction ends
 * @param onHoverChange - Handler that is called when the hover state changes
 */
exports.FlatButton = react_1.default.forwardRef(function (_a, ref) {
    var onDarkBackground = _a.onDarkBackground, children = _a.children, props = __rest(_a, ["onDarkBackground", "children"]);
    var _b = useButtonState({
        isDisabled: props.isDisabled,
        isPending: props.isPending,
    }), isDisabled = _b.isDisabled, isPending = _b.isPending;
    return (react_1.default.createElement(StyledFlatButton, __assign({}, props, { ref: ref, isDisabled: isDisabled, isPending: isPending, onDarkBackground: onDarkBackground }), children));
});
var StyledDestructiveButton = (0, styled_1.default)(react_aria_components_1.Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styles_1.DestructiveButtonStyles);
/**
 * The destructive button variant, used for dangerous or irreversible actions.
 * It has a red color scheme to indicate caution.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Button.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-buttons--destructive}
 *
 * @example
 * ```tsx
 * <DestructiveButton onPress={() => handleDelete()}>
 *   Delete
 * </DestructiveButton>
 * ```
 *
 * @param children - The content to display inside the button
 * @param isDisabled - Whether the button is disabled. Defaults to false
 * @param type - The behavior of the button when used in an HTML form. Defaults to 'button'
 * @param onPress - Handler that is called when the press is released over the target
 * @param onPressStart - Handler that is called when a press interaction starts
 * @param onPressEnd - Handler that is called when a press interaction ends
 * @param onPressChange - Handler that is called when the press state changes
 * @param onPressUp - Handler that is called when a press is released over the target
 * @param onKeyDown - Handler that is called when a key is pressed
 * @param onKeyUp - Handler that is called when a key is released
 * @param onKeyPress - Handler that is called when a key is pressed
 * @param onFocus - Handler that is called when the button receives focus
 * @param onBlur - Handler that is called when the button loses focus
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param autoFocus - Whether the button should receive focus on render. Defaults to false
 * @param onHoverStart - Handler that is called when a hover interaction starts
 * @param onHoverEnd - Handler that is called when a hover interaction ends
 * @param onHoverChange - Handler that is called when the hover state changes
 */
exports.DestructiveButton = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = useButtonState({
        isDisabled: props.isDisabled,
        isPending: props.isPending,
    }), isDisabled = _b.isDisabled, isPending = _b.isPending;
    return (react_1.default.createElement(StyledDestructiveButton, __assign({}, props, { ref: ref, isDisabled: isDisabled, isPending: isPending }), children));
});
var StyledIconButton = (0, styled_1.default)(react_aria_components_1.Button)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styles_1.IconButtonStyles);
/**
 * A button variant specifically designed for icon-only buttons.
 * It has a circular shape and is optimized for displaying icons.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Button.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-buttons--icon}
 *
 * @example
 * ```tsx
 * <IconButton onPress={() => alert('Clicked')}>
 *   <Icon name="close" />
 * </IconButton>
 * ```
 *
 * @param children - The icon to display inside the button
 * @param size - The size of the icon button. Defaults to 'default'
 * @param onDarkBackground - Whether the button is being used on a dark background. Defaults to false
 * @param isDisabled - Whether the button is disabled. Defaults to false
 * @param type - The behavior of the button when used in an HTML form. Defaults to 'button'
 * @param onPress - Handler that is called when the press is released over the target
 * @param onPressStart - Handler that is called when a press interaction starts
 * @param onPressEnd - Handler that is called when a press interaction ends
 * @param onPressChange - Handler that is called when the press state changes
 * @param onPressUp - Handler that is called when a press is released over the target
 * @param onKeyDown - Handler that is called when a key is pressed
 * @param onKeyUp - Handler that is called when a key is released
 * @param onKeyPress - Handler that is called when a key is pressed
 * @param onFocus - Handler that is called when the button receives focus
 * @param onBlur - Handler that is called when the button loses focus
 * @param onFocusChange - Handler that is called when the focus state changes
 * @param autoFocus - Whether the button should receive focus on render. Defaults to false
 * @param onHoverStart - Handler that is called when a hover interaction starts
 * @param onHoverEnd - Handler that is called when a hover interaction ends
 * @param onHoverChange - Handler that is called when the hover state changes
 */
exports.IconButton = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = useButtonState({
        isDisabled: props.isDisabled,
        isPending: props.isPending,
    }), isDisabled = _b.isDisabled, isPending = _b.isPending;
    return (react_1.default.createElement(StyledIconButton, __assign({}, props, { ref: ref, isDisabled: isDisabled, isPending: isPending }), children));
});
var StyledLinkButton = (0, styled_1.default)(react_aria_components_1.Button)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), Links_1.LinkButtonStyles);
/**
 * A button variant that looks like a link.
 * It has no background or border and uses link styling.
 *
 * @see {@link https://react-spectrum.adobe.com/react-aria/Button.html}
 * @see {@link https://compass.circleci.com/?path=/story/rac-buttons--link}
 *
 * @example
 * // Basic usage
 * <LinkButton onPress={() => alert('Clicked')}>
 *   Learn more
 * </LinkButton>
 *
 * @example
 * // With disabled state
 * <LinkButton isDisabled>
 *   Learn more
 * </LinkButton>
 *
 * @param children - `React.ReactNode` - The content to display inside the button
 * @param isDisabled - `boolean` - Whether the button is disabled
 * @param type - `'button' | 'submit' | 'reset'` - The behavior of the button when used in an HTML form
 * @param onPress - `(e: PressEvent) => void` - Handler that is called when the press is released over the target
 * @param onPressStart - `(e: PressEvent) => void` - Handler that is called when a press interaction starts
 * @param onPressEnd - `(e: PressEvent) => void` - Handler that is called when a press interaction ends, either over the target or when the pointer leaves the target
 * @param onPressChange - `(isPressed: boolean) => void` - Handler that is called when the press state changes
 * @param onPressUp - `(e: PressEvent) => void` - Handler that is called when a press is released over the target, regardless of whether it started on the target or not
 * @param onKeyDown - `(e: KeyboardEvent) => void` - Handler that is called when a key is pressed
 * @param onKeyUp - `(e: KeyboardEvent) => void` - Handler that is called when a key is released
 * @param onKeyPress - `(e: KeyboardEvent) => void` - Handler that is called when a key is pressed
 * @param onFocus - `(e: FocusEvent) => void` - Handler that is called when the button receives focus
 * @param onBlur - `(e: FocusEvent) => void` - Handler that is called when the button loses focus
 * @param onFocusChange - `(isFocused: boolean) => void` - Handler that is called when the focus state changes
 * @param autoFocus - `boolean` - Whether the button should receive focus on render
 * @param onHoverStart - `() => void` - Handler that is called when a hover interaction starts
 * @param onHoverEnd - `() => void` - Handler that is called when a hover interaction ends
 * @param onHoverChange - `(isHovered: boolean) => void` - Handler that is called when the hover state changes
 * @returns {JSX.Element} Returns the link button component
 */
exports.LinkButton = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = useButtonState({
        isDisabled: props.isDisabled,
        isPending: props.isPending,
    }), isDisabled = _b.isDisabled, isPending = _b.isPending;
    return (react_1.default.createElement(StyledLinkButton, __assign({}, props, { ref: ref, isDisabled: isDisabled, isPending: isPending }), children));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=index.js.map